module.exports = __webpack_public_path__ + "static/thumb-2-19f28fdd82fbd4f18b8bff46c35e9356.jpg";